import { computeUpTransLabel } from "@/models/equipment/step_up_transformer/properties";
import type { RenderScenarioExportCols } from "./sizingExportTypes";

export const renderStepUpXfmrCols: RenderScenarioExportCols = ({
  scenario,
  calcs,
  targetUnits
}) => [
  {
    section: "S/U XFMR",
    label: "XFMR Description",
    targetUnit: null,
    value: computeUpTransLabel(scenario.equipment.value?.r_step_up_transformer)
  },
  {
    section: "S/U XFMR",
    label: "Surface Required Volts",
    targetUnit: targetUnits.voltageUnit,
    value: calcs.surfaceDriveCalculations.requiredVoltageV
  },
  {
    section: "S/U XFMR",
    label: "Total Voltage Loss",
    targetUnit: targetUnits.voltageUnit,
    value: calcs.cableCalculations.aggregate.totalCablesVoltLossV
  },
  {
    section: "S/U XFMR",
    label: "Transformer Ratio",
    targetUnit: null,
    value: calcs.surfaceDriveCalculations.transformerRatio
  }
];
